const DEV_STRIPE_PUBLISHABLE_KEY = 'pk_test_51I68jHKqA9pdknOZWY5yB4PR8iVmQpyoirXCs4x1wAmSjd19webviVSgO5fb82TLPOoEb7Oiw3PhhQIFBQwgAe8H00X3JyGamp';
const PROD_STRIPE_PUBLISHABLE_KEY = 'pk_live_51I68jHKqA9pdknOZKSqrfDQGd9Ak5fZ0TYIdw3MLlm0yyoktoGLTsMpoARvGddnpcYm3MX1Dsnn63mkWHVtPb6Vj00b65iP3Hg'

export const STRIPE_PUBLISHABLE_KEY = process.env.NODE_ENV === 'production' ? PROD_STRIPE_PUBLISHABLE_KEY : DEV_STRIPE_PUBLISHABLE_KEY;
